module.exports = __webpack_public_path__ + "static/media/screen1.7843cacc.png";